import { Button } from "antd";
import { styled } from "styled-components";
import { CloseOutlined } from "@ant-design/icons";
import { LeftArrowIcon } from "@dataone/icons";
import { OneGateLogo_3Icon } from "@dataone/icons";
interface RedirectionPaeProps {
  selectedPage: { index: number; id: string; name: string };
  selectedDashboard: {
    index: number;
    id: string;
    name: string;
  };
  handleCancel: () => void;
  handleGoBack: () => void;
  redirectToDashboard: () => void;
  isSendTable: boolean;
}

const RedirectionPage = ({
  selectedPage,
  selectedDashboard,
  handleCancel,
  handleGoBack,
  redirectToDashboard,
  isSendTable,
}: RedirectionPaeProps) => {
  return (
    <Container>
      <Header>
        <GoBackBtn onClick={handleGoBack}>
          <LeftArrowIcon />
          <span>Go Back</span>
        </GoBackBtn>
        <StyledCloseOutlined onClick={handleCancel} />
      </Header>
      <StyledRedirectionPage>
        <Logo>
          <OneGateLogo_3Icon />
        </Logo>
        <Message>
          ALL good ! Your {isSendTable ? "Table" : "chart"} has been added to
          <br />
          <span>
            {selectedDashboard.name} / {selectedPage.name}
          </span>
        </Message>
        <Footer>
          <Button className="primary-btn" onClick={handleCancel}>
            Continue Searching
          </Button>
          <Button className="secondary-btn" onClick={redirectToDashboard}>
            Go to Dashboard
          </Button>
        </Footer>
      </StyledRedirectionPage>
    </Container>
  );
};

export default RedirectionPage;
const Container = styled.div`
  width: 100%;
  height: 100%;
`;
const StyledCloseOutlined = styled(CloseOutlined)`
  cursor: pointer;
`;
const GoBackBtn = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 700;
  cursor: pointer;
  svg {
    font-size: 22px;
    color: #000;
  }
`;
const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const Logo = styled.div`
  display: flex;
  color: #70bf42;
  font-size: 130px;
`;
const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  .primary-btn {
    width: 180px;
    height: 40px;
    color: #4974f6;
    border: none;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    border-radius: 10px;
    background: var(--black-100, #fff);
    box-shadow: 0px 4px 4px 0px rgba(73, 116, 246, 0.25) inset;
    &:hover {
      border: none !important;
      box-shadow: 0px 4px 4px 0px rgba(73, 116, 246, 0.25) inset !important;
      color: #4974f6 !important;
    }
  }
  .secondary-btn {
    width: 180px;
    height: 40px;
    border: 1px solid #4974f6;
    color: #4974f6;
    border: none;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    border-radius: 10px;
    background: #eff1fd;
    &:hover {
      border: none !important;
      color: #4974f6 !important;
    }
  }
`;
const Message = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #000000;
  text-align: center;
  span {
    color: #4974f6;
  }
`;
const StyledRedirectionPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 100%;
`;
